import { BsPlusCircle, BsPlusCircleFill, BsTrash } from "react-icons/bs";
import styled from "styled-components";
import {
  BiSelectMultiple,
  BiCheckbox,
  BiCheckboxChecked,
} from "react-icons/bi";

export const AddFile = styled(BsPlusCircleFill)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const AddFileHover = styled(BsPlusCircle)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;
export const LoadFileLink = styled.a`
  position: relative;
  &:hover {
    background-color: ${(props) => props.bg};
  }
`;

export const SelectButton = styled(BiSelectMultiple)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const SelectComponent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(props) => props.check && "black"};
  opacity: ${(props) => props.check && "0.4"};
  cursor: pointer;
`;

export const Check = styled(BiCheckbox)`
  color: #3948ff;
  font-size: 1.8rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const Checked = styled(BiCheckboxChecked)`
  color: #3948ff;
  font-size: 1.8rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const RemoveBtn = styled(BsTrash)`
  color: #3948ff;
  font-size: 2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;
